import axios from "axios";

// Base URLs from environment
export const apiUrl = process.env.REACT_APP_API_URL;

/**
 * Generic request without token (Admin APIs)
 */
export const requestWithoutToken = async (method, url, body) => {
  const fullUrl = apiUrl + url;
  const headers = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  switch (method) {
    case "GET":
      return axios.get(fullUrl, headers);
    case "POST":
      return axios.post(fullUrl, body, headers);
    case "PUT":
      return axios.put(fullUrl, body, headers);
    case "DELETE":
      return axios.delete(fullUrl, { data: body, ...headers });
    default:
      return Promise.reject(new Error("Unsupported method"));
  }
};

/**
 * Generic request with token (Admin APIs)
 */
export const requestWithToken = (method, url, body) => {
  const fullUrl = apiUrl + url;
  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  let request;
  switch (method) {
    case "GET":
      request = axios.get(fullUrl, headers);
      break;
    case "POST":
      request = axios.post(fullUrl, body, headers);
      break;
    case "PUT":
      request = axios.put(fullUrl, body, headers);
      break;
    case "DELETE":
      request = axios.delete(fullUrl, { data: body, ...headers });
      break;
    default:
      return Promise.reject(new Error("Unsupported method"));
  }

  return request.catch((error) => {
    // if (error.response?.status === 401) {
    //   localStorage.removeItem("token");
    //   sessionStorage.clear();
    //   window.location.href = "/login"; // redirect on session expiry
    // }
    return Promise.reject(error);
  });
};

